import classnames from 'classnames'
import React from 'react'

import './style.css'

type HTMLDivProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>

const Card = (props: HTMLDivProps) => {
  return (
    <div
      {...props}
      className={classnames('drift-widget-card', props.className)}
      tabIndex={-1}
    >
      {props.children}
    </div>
  )
}

export default Card
